import { PublicDataServerNotConfiguredError } from './errors';

let publicDataBaseUri: string | undefined;

/**
 * Sets the base URI of the server hosting the public (unauthenticated) data sets:
 * leaked password hash ranges, the list of TOTP-capable sites and the breach
 * logos. A trailing slash is accepted.
 */
export function setPublicDataBaseUri(baseUri: string) {
  publicDataBaseUri = baseUri.replace(/\/+$/, '');
}

function requirePublicDataBaseUri() {
  if (!publicDataBaseUri) {
    throw new PublicDataServerNotConfiguredError();
  }
  return publicDataBaseUri;
}

/** The prefix is expected to be the first five hex digits of a SHA-1. */
export function getLeakedPasswordRangeUri(sha1Prefix: string) {
  return `${requirePublicDataBaseUri()}/pwnedpasswords/range/${sha1Prefix}`;
}

export function getTotpDirectoryUri() {
  return `${requirePublicDataBaseUri()}/2fa/totp.json`;
}

/** The file name is expected to be the one the backend reports for a breach. */
export function getBreachLogoUri(logoFileName: string) {
  return `${requirePublicDataBaseUri()}/hibplogos/${logoFileName}`;
}
